import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import App from './App';
import { theme } from './theme';

// Initialised before React mounts so errors thrown during the first render are
// captured. Guarded on the env var, so local development sends nothing and needs
// no configuration to stay out of the Grafana stack.
if (import.meta.env.VITE_FARO_URL) {
  initializeFaro({
    url: import.meta.env.VITE_FARO_URL,
    app: {
      name: import.meta.env.VITE_FARO_APP_NAME ?? 'docent-web',
      version: __APP_VERSION__,
      environment: import.meta.env.VITE_APP_ENV ?? 'unknown',
    },
    instrumentations: [...getWebInstrumentations({ captureConsole: true })],
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>,
);
